/**
 * Main purpose of this AsyncStorage helper is to be provide a signature which is compliant with the
 * ReactNative AsyncStorage module (since our stack is used on Web Browser and on ReactNative)
 *
 * This class is a simple wrapper to :
 * - Uses promise notation for getter/setter of browser's localStorage
 * - Expose multiGet, multiSet and multiRemove methods which natively do not exists on localStorage
 */
const AsyncStorage = {
    getItem(key) {
        return Promise.resolve(localStorage.getItem(key))
    },

    setItem(key, value) {
        localStorage.setItem(key, value)
        return Promise.resolve()
    },

    removeItem(key) {
        localStorage.removeItem(key)
        return Promise.resolve()
    },

    multiGet(keys) {
        return Promise.resolve(keys.map(k => [k, localStorage.getItem(k)]))
    },

    multiSet(keyValuePairs) {
        keyValuePairs.forEach(([k, v]) => {
            localStorage.setItem(k, v)
        })

        return Promise.resolve()
    },

    multiRemove(keys) {
        keys.forEach(k => localStorage.removeItem(k))
        return Promise.resolve()
    },
}

export default AsyncStorage
